module.exports = __webpack_public_path__ + "static/media/rt.0255194a.jpg";